import choose from '@src/static/images/icon/landing/choose.svg';
import hotCup from '@src/static/images/icon/landing/hot-cup.svg';
import location from '@src/static/images/icon/landing/location.svg';
import videoThumbnail from '@src/static/images/video-thumbnail.png';
import Image from 'next/image';
import Link from 'next/link';
import React, { Component } from 'react';

import Bio from '../category/Bio';
import CategoryBreadcrumb from '../category/CategoryBreadCrumb';
import Reviews from '../category/Reviews';
import Breadcrumb from '../home/breadcrumb.jsx';
import FeedbackModal from '../modals/FeedbackModal';
import VideoModal from '../modals/VideoModal';
import CampaignBanner from './CampaignBanner';
import DetailsWithPrice from './details-price.jsx';
import DetailsTopTabs from './details-top-tabs.jsx';
import Gallery from './Gallery';
import RelatedProduct from './related-products';
import Service from './service-new.jsx';

var bio = null;

class Product extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalTermsOfServiceOpen: false,
			termsOfServiceContent: '',
			bio: null,
			showUpsellOverlay: false,
			showVideoModal: false,
		};
	}

	onOpenModal = () => {
		this.setState({ modalTermsOfServiceOpen: true });
	};

	onCloseModal = () => {
		this.setState({ modalTermsOfServiceOpen: false });
	};

	componentDidMount() {
		const { item } = this.props;
		if (item) {
			var trackItem = {
				product_id: item.bigCommerceId,
				sku: item.sku,
				name: item.name,
				price: item.price,
				category: item.categoryId,
				brand: item.brandId,
			};
			bio = item ? (item.selectedProviderService ? item.selectedProviderService.providerId : null) : null;
			this.setState({ bio: bio });

			analytics.track('Product Viewed', trackItem);

			window.addEventListener('load', () => {
				gbTracker.sendViewProductEvent({
					product: {
						productId: item.bigCommerceId,
						title: item.name,
						price: item.price,
						category: item.category?.id || 2,
						sku: item.sku,
					}
				});
			});

			if (this.props.renderTransferOverlay) {
				setTimeout(() => {
					this.setState({ showUpsellOverlay: true });
				}, 2000);
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { item } = this.props;

		if (prevProps.item !== this.props.item) {
			bio = item ? (item.selectedProviderService ? item.selectedProviderService.providerId : null) : null;
			this.setState({ bio: bio });
		}
	}

	render() {
		const {
			symbol,
			item,
			addToCart,
			addToCartUnsafe,
			addToWishlist,
			addToCompare,
			crossreferenceid,
			applicationLabel,
			category,
			breadcrumbs,
			provider,
			cartlist,
			reviews,
			setSelectedProvider,
			providerLocation,
			masterProvider,
			geolocation,
			productIsLoading,
		} = this.props;
		const { bio } = this.state;

		var applicationProducts = this.props.applicationProducts;
		if (applicationProducts != undefined && item != undefined) {
			applicationProducts = applicationProducts.filter(applicationProducts => {
				return applicationProducts.id != item.id;
			});
		}

		return (
			<div className="page product">
				{breadcrumbs.length > 0 && category ? (
					<CategoryBreadcrumb category={category} breadcrumbs={breadcrumbs} />
				) : (
					<Breadcrumb title={item.name} />
				)}

				<div className="inner">
					<div className="container">
						<div className="row">
							<div className="col-xl-3 left-content services">
								<div className="related-products-wrapper">
									<Service item={item} />

									<RelatedProduct
										productList={applicationProducts}
										applicationSlug={crossreferenceid}
										addToCart={addToCartUnsafe}
										addToCompare={addToCompare}
										addToWishlist={addToWishlist}
									/>
								</div>
							</div>

							<div className="col-xl-9">
								<div className="row">
									<div className="col-lg-7 col-md-6 col-12 center">
										{item?.productPictures && <Gallery images={item.productPictures} />}
									</div>

									<div className="col-lg-5 col-md-6 col-12 right-sidebar">
										<div className="discounts">
											<FeedbackModal
												open={this.state.modalTermsOfServiceOpen}
												type="info"
												title="Terms of Service"
												content={this.state.termsOfServiceContent}
												onCloseModal={this.onCloseModal}
												confirmAction={this.onCloseModal}
												buttonConfirm={'OK'}
											/>
											<CampaignBanner campaigns={item.campaigns} />
										</div>

										<DetailsWithPrice
											renderTransferOverlay={this.props.renderTransferOverlay}
											cartlist={cartlist}
											symbol={symbol}
											item={item}
											addToCartClicked={addToCart}
											BuynowClicked={addToCartUnsafe}
											addToWishlistClicked={addToWishlist}
											applicationLabel={applicationLabel}
											applicationSlug={crossreferenceid}
											setSelectedProvider={setSelectedProvider}
											provider={provider}
											geolocation={geolocation}
											productIsLoading={productIsLoading}
											showReviews={
												!masterProvider || (masterProvider && !masterProvider.isActive)
											}
											reviews={reviews}
											showFitment={true}
										/>
									</div>
								</div>

								{!this.props.renderTransferOverlay && <Reviews type="textBanner" reviews={reviews} />}
								{this.props.renderTransferOverlay && (
									<>
										<VideoModal
											open={this.state.showVideoModal}
											onCloseModal={() => this.setState({ showVideoModal: false })}
										/>
										<div className={`banner-with-sample-report align-middle`}>
											<div className="inner">
												<div className="container">
													<div className="row">
														<div className="col-md-8 align-middle">
															<div className="text">
																<h3>How the Process Works</h3>
																<p>
																	This is the easiest to use Battery platform in the
																	world today, combining the best about DoorDash,
																	Uber, and making the installation of batteries
																	transparent and cheaper for you. From Prices to
																	Delivery, we keep you informed and no hidden fees.
																	If you have any questions we are always available.
																	Please watch the 90 second video for more info.
																</p>
															</div>
														</div>

														<div className="col">
															<div
																className="image"
																onClick={() => this.setState({ showVideoModal: true })}>
																<div>
																	<Image
																		width="400px"
																		height="229px"
																		src={videoThumbnail}
																		alt="Car Battery Installation Video"
																		className="lazyload"
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div className="steps mb-2">
											<div className="container">
												<div className="inner">
													<div className="row">
														<div className="col">
															<Link href={`/category/${item.category.urlSlug}`}>
																<div className="item">
																	<span className="start-here">Start Here</span>
																	<img
																		src={location.src}
																		alt=""
																		className="lazyload"
																	/>

																	<h4>Step 1</h4>
																	<h6>Provide your Information</h6>
																	<p>
																		We will provide an immediate price quote based
																		on your vehicle model and location.
																	</p>
																</div>
															</Link>
														</div>

														<div className="col">
															<Link href={`/category/${item.category.urlSlug}`}>
																<div className="item">
																	<img src={choose.src} alt="" className="lazyload" />

																	<h4>Step 2</h4>
																	<h6>Select your Service Option</h6>
																	<p>
																		We offer{' '}
																		<span>Pickup, Delivery and Installation</span>{' '}
																		options.
																	</p>
																</div>
															</Link>
														</div>

														<div className="col">
															<Link href={`/category/${item.category.urlSlug}`}>
																<div className="item no-affirm-disclaimer-border">
																	<img src={hotCup.src} alt="" className="lazyload" />

																	<h4>Step 3</h4>
																	<h6>Place your order and we do the rest.</h6>
																	<p>
																		If you choose Delivery we’ll come to you. If you
																		choose a Store our Technicians will be waiting
																		for you.
																	</p>
																</div>
															</Link>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div className="bottom-container">
											<div>
												<div className="bottom">
													<div className="tagline-container">
														<h3>About Us</h3>
														<p className="tagline">
															We are the <strong>largest Battery Marketplace</strong> in
															North America. Over <strong>10,000</strong> products,{' '}
															<strong>250,000</strong> locations, and{' '}
															<strong>1,000,000 </strong> needs served.
														</p>
													</div>

													<div className="items-container">
														<h3>Our Services</h3>

														<div className="item">
															<div className="img">
																<i
																	className="fas fa-shipping-fast"
																	aria-hidden="true"></i>
															</div>
															<div className="text">
																<h5>FAST DELIVERY</h5>
																<p>Most orders are 90 minutes or Less</p>
															</div>
														</div>
														<div className="item">
															<div className="img">
																<i
																	className="fad fa-calendar-check"
																	aria-hidden="true"></i>
															</div>
															<div className="text">
																<h5 className="">Make an Appointment</h5>
																<p className="">
																	Not an Emergency, schedule an appointment at your
																	around your busy schedule.
																</p>
															</div>
														</div>
														<div className="item">
															<div className="img">
																<i className="fad fa-wrench" aria-hidden="true"></i>
															</div>
															<div className="text">
																<h5 className="">PROFESSIONAL INSTALLATION!</h5>
																<p className="">
																	We Test Electrical, Install New Battery, Test Again
																	and Recycle old Battery{' '}
																	<small>(Computer Resets too)</small>
																</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</>
								)}
								<div className="row">
									<div className="col-12">
										<DetailsTopTabs item={item} />
										{bio && bio.ShowBio ? (
											<Bio
												showFitmentDisclaimer={false}
												imageUrl={bio.DriverImageUrl}
												name={bio.Name}
												quote={bio.DriverBio}
											/>
										) : (
											<></>
										)}
									</div>
								</div>

								<div className="row">
									<div className="col-xl-12 bottom-content services">
										<Service item={item} providerLocation={providerLocation} />

										<RelatedProduct
											productList={applicationProducts}
											applicationSlug={crossreferenceid}
											addToCart={addToCartUnsafe}
											addToCompare={addToCompare}
											addToWishlist={addToWishlist}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default Product;
